import { h } from 'preact';
import './styles.less';
import { route } from 'preact-router';
import UserIcon from '../Icon/User';
import { getCatalogueTheme } from '../../lib/Theme';
import { getCustomerOrderPortalRoute } from '../../lib/customerOrders';
import { clearCachedScrollPositions } from '../../lib/ScrollPosition';
import { shouldProcessClick } from '../../lib/Utils';
import { getThemeId } from '../../lib/Amalgam';

const CustomerProfile = () => {
  const { homeGrid, themeTextColor } = getCatalogueTheme();
  const profileIconColor =
    homeGrid.searchClass === 'dark'
      ? getThemeId() === 'dark'
        ? themeTextColor
        : '#fff'
      : homeGrid.searchIconColor;

  const goClickCustomerProfile = () => {
    const orderRoute = getCustomerOrderPortalRoute();
    route(orderRoute);
  };

  const onClickUserIcon = (event) => {
    if (!shouldProcessClick(event)) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    clearCachedScrollPositions();
    goClickCustomerProfile();
  };

  return (
    <a
      href={getCustomerOrderPortalRoute()}
      title="profile page with order history"
      target="_blank"
      className="customer-profile-button"
      onClick={onClickUserIcon}
      rel="noopener noreferrer"
    >
      <UserIcon size={28} className="user-icon" color={profileIconColor} />
    </a>
  );
};

export default CustomerProfile;
